<!DOCTYPE html>
<html>

<head>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <title>Login Form Using HTML And CSS Only</title>
</head>

<body class="login-bg">
    <div class="container">
        <div class="form-container log-in-container">
            <form [formGroup]="myForm">
                <br/>
                <img src="/assets/images/pet-logo.png" class="logo">
                <!-- <button (click)="ByPassLogin()">Log In</button> -->
                <button (click)="AzureADLogin()">Azure AD Log In</button>
            </form>
        </div>
        <div class="overlay-container">
            <div class="overlay">
                <div class="overlay-panel overlay-right">
                    <h1 class="project">PrAnSpan</h1>
                    <div class="login-footer-container">
                        <div>
                            <p> 
                                <a href="" target="_blank">Privacy Policy</a> 
                                | 
                                <a  href="" target="_blank" class="ng-binding">Use Terms &amp; Conditions</a>
                            </p>
                        </div>
                        <div>
                            <h4>{{environment}}</h4>
                            <h5>Version {{version}}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
</html>